import { Colour } from './Colour'

export interface Colourable{
    isColourable(): Boolean;
    getColour(index: ColourIndex): Colour;
    setColour(index: ColourIndex, colour: Colour): void;
    setColouringMode(mode: ColouringMode): void;
    getColouringMode():ColouringMode;
}

export class ObjColourManager{

    public colourMode: ColouringMode = ColouringMode.Fill
    public colourType: FillType = FillType.Colour

    protected colours: Array<Colour> = [new Colour({h:80, s:1, v:0.75}), new Colour({h: 173, s:1, v:0.47})] //Fill = green , Stroke = blue-green

    setColouringMode(newMode: ColouringMode){
        this.colourMode = newMode
    }

    setColour(colour: Colour, mode: ColourIndex){
        this.colours[mode] = colour;
        //console.log("colable, set color as "+colour.getColor()+" mode:"+mode);
    }

    getColour(mode: ColourIndex): Colour{
        return this.colours[mode];
    }

    getColouringMode(): ColouringMode{
        return this.colourMode;
    }

    setupCanvas(canvasCtx : CanvasRenderingContext2D){
        switch(this.colourMode){
            case ColouringMode.None:
                canvasCtx.fillStyle = this.colours[ColourIndex.Fill].getColorWithAlpha(0);
                canvasCtx.strokeStyle = this.colours[ColourIndex.Stroke].getColorWithAlpha(0);
                break;
            case ColouringMode.Fill:
                canvasCtx.fillStyle = this.colours[ColourIndex.Fill].getColor();
                canvasCtx.strokeStyle = this.colours[ColourIndex.Stroke].getColorWithAlpha(0);
                break;
            case ColouringMode.Stroke:
                canvasCtx.fillStyle = this.colours[ColourIndex.Fill].getColorWithAlpha(0);
                canvasCtx.strokeStyle = this.colours[ColourIndex.Stroke].getColor();
                break;
            case ColouringMode.FillAndStroke:
                canvasCtx.fillStyle = this.colours[ColourIndex.Fill].getColor();
                canvasCtx.strokeStyle = this.colours[ColourIndex.Stroke].getColor();
                break;
        }
    }

    clone(): ObjColourManager{
        var clone = new ObjColourManager();
        clone.colourMode = this.colourMode;
        clone.colourType = this.colourType;
        for(var i = 0; i<this.colours.length; i++){
            clone.setColour(new Colour(this.colours[i].getHsv()), i);
        }
        return clone;
    }
}

export enum FillType{
    Colour,
    Gradient
}

export enum ColourIndex{
    Fill=0,
    Stroke=1
}

export enum ColouringMode{
    None = 0,
    Fill = 1,
    Stroke = 2,
    FillAndStroke = 3
}